import React, { useState, useEffect } from "react"
import { Row, Col, Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input } from "reactstrap"
import Datatables from "components/Datatables/datatable"
import { get, post } from "helpers/api_helper"
import { PAYROLL_PAYMENT_METHODS_URL } from "helpers/url_helper"
import Notifications from "components/Notifications"

const PaymentMethod = () => {
    const [modal, setModal] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [dataRows, setDataRows] = useState({ rows: [], total_rows: 0 })
    
    const [formData, setFormData] = useState({
        method_name: ""
    })

    const toggleModal = () => {
        if (modal) {
            setFormData({ method_name: "" })
            setIsEdit(false)
        }
        setModal(!modal)
    }

    const brownBtnStyle = { backgroundColor: "#3d1e08", borderColor: "#3d1e08", color: "#fff" }

    const getData = async () => {
        setIsLoading(true)
        const res = await get(PAYROLL_PAYMENT_METHODS_URL)
        if (res.status === 200) {
            setDataRows(res.response)
        }
        setIsLoading(false)
    }

    useEffect(() => {
        getData()
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault()
        const res = isEdit 
            ? await post(`${PAYROLL_PAYMENT_METHODS_URL}_update`, formData)
            : await post(PAYROLL_PAYMENT_METHODS_URL, formData)
            
        if (res.status === 200 || res.status === true) {
            Notifications("success", res.message)
            toggleModal()
            getData()
        } else {
            Notifications("error", res.message)
        }
    }

    const handleEdit = (row) => {
        setFormData({ ...row })
        setIsEdit(true)
        setModal(true)
    }

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this payment method?")) {
            const res = await get(`${PAYROLL_PAYMENT_METHODS_URL}_delete?id=${id}`)
            if (res.status === 200 || res.status === true) {
                Notifications("success", res.message)
                getData()
            } else {
                Notifications("error", res.message)
            }
        }
    }

    const columns = [
        { dataField: "id", text: "#" },
        { dataField: "method_name", text: "PAYMENT METHOD" },
        {
            dataField: "status",
            text: "STATUS",
            formatter: (cell) => (
                <div className="form-check form-switch" dir="ltr">
                    <input type="checkbox" className="form-check-input" defaultChecked={cell == 1} />
                </div>
            )
        },
        {
            dataField: "action",
            text: "ACTION",
            formatter: (cell, row) => (
                <>
                    <Button color="light" size="sm" className="me-1" onClick={() => handleEdit(row)}><i className="far fa-edit text-primary"></i></Button>
                    <Button color="light" size="sm" onClick={() => handleDelete(row.id)}><i className="far fa-times-circle text-danger"></i></Button>
                </>
            )
        }
    ]

    return (
        <React.Fragment>
            <Datatables 
                title="Payment Methods"
                titleClass="h5"
                columns={columns} 
                rows={dataRows.rows} 
                keyField="id" 
                isSearch={false} 
                isAdd={true} 
                btnTitle="Add Method"
                btnColor="success"
                handleAddButton={toggleModal}
                loading={isLoading} 
            />

            <Modal isOpen={modal} toggle={toggleModal} size="lg">
                <ModalHeader toggle={toggleModal}>{isEdit ? "Edit" : "Add"} Payment Method</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col md={12}>
                                <FormGroup>
                                    <Label>Method Name <span className="text-danger">*</span></Label>
                                    <Input 
                                        type="text" 
                                        placeholder="e.g. Bank Transfer, Cash, Check" 
                                        value={formData.method_name}
                                        onChange={(e) => setFormData({ ...formData, method_name: e.target.value })}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="mt-3">
                            <Button style={brownBtnStyle} type="submit">{isEdit ? "Update" : "Create"}</Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>
        </React.Fragment>
    )
}

export default PaymentMethod
